import { render, staticRenderFns } from "./contactInfo.vue?vue&type=template&id=53eff5f0"
import script from "./contactInfo.vue?vue&type=script&lang=js"
export * from "./contactInfo.vue?vue&type=script&lang=js"
import style0 from "./contactInfo.vue?vue&type=style&index=0&id=53eff5f0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports